import { render, staticRenderFns } from "./GridResize.vue?vue&type=template&id=16310800&scoped=true&lang=pug"
import script from "./GridResize.vue?vue&type=script&lang=ts"
export * from "./GridResize.vue?vue&type=script&lang=ts"
import style0 from "./GridResize.vue?vue&type=style&index=0&id=16310800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16310800",
  null
  
)

export default component.exports